import React, { useMemo } from "react";
import { Icon } from "@shared/components";

import "./index.scss";

interface PatientCardStablePeriodInfoProps {
  signalName: string;
  stablePeriod: number;
  stableAvgPeriod: number;
  stablePeriodPercentage: number;
}

const PatientCardStablePeriodInfo = ({
  signalName,
  stableAvgPeriod,
  stablePeriod,
  stablePeriodPercentage,
}: PatientCardStablePeriodInfoProps) => {
  const percentageColor = useMemo(() => {
    return stablePeriod < stableAvgPeriod ? "green" : "red";
  }, [stablePeriod, stableAvgPeriod]);

  const percentageIcon = useMemo(() => {
    return stablePeriod < stableAvgPeriod ? "percentage-up" : "percentage-down";
  }, [stablePeriod, stableAvgPeriod]);

  return (
    <div className="patients-card-stable-period-info">
      <div className="patients-card-stable-period-info-row">
        <span className="signal-name">{signalName}</span>
      </div>
      <div className="patients-card-stable-period-info-row">
        <span className="stable-avg-value">{stableAvgPeriod ? stableAvgPeriod : `-`}</span>
      </div>
      <div className="patients-card-stable-period-info-row">
        {stablePeriodPercentage ? <Icon className="stable-percentage-icon" type={`${percentageIcon}`} /> : null}
        <span className={`stable-percentage-value ${percentageColor}`}>{stablePeriodPercentage}%</span>
        <span className="stable-period">Stable Period: {stablePeriod ? ` ${stablePeriod}` : "-"}</span>
      </div>
    </div>
  );
};

export default PatientCardStablePeriodInfo;
